import { useCallback, useRef } from 'react';

export const useScrollToTab = (): [React.RefObject<HTMLUListElement>, (selectedTabId: number) => void] => {
  /**
   * Category container Ref
   * @type {*}
   */
  const scrollContainerRef = useRef<HTMLUListElement>(null);

  const scrollTo = useCallback(
    async (selectedTabId: number | undefined) => {
      const selectedTab = document.getElementById(`category_${selectedTabId}`);

      // Scroll to category
      if (scrollContainerRef.current && selectedTab?.offsetLeft) {
        selectedTab.scrollIntoView({ behavior: 'smooth' });
      }
    },
    [scrollContainerRef.current]
  );

  return [scrollContainerRef, scrollTo];
};
